// src/js/actions/index.js
import * as types from "../constants/action-types";
import AdminApi from '../api/adminApi';
import AuthService from '../utils/authService';
import { beginAjaxCall, errorAjaxCall } from './ajaxStatus';


export function removeSuccess(type, item) { return { ...type, item } };
export function loadSuccess(type, items) { return { ...type, items } };

export function loadMenuSuccess(menu) { return { type: types.LOAD_MENU_SUCCESS, menu } };

export function getUserSuccess(user) { return { type: types.GET_USER_SUCCESS, user } };
export function updateUserSuccess(user) { return { type: types.UPDATE_USER_SUCCESS, user } };
export function createUserSuccess(user) { return { type: types.CREATE_USER_SUCCESS, user } };

export function loadRolesSuccess(roles) { return { type: types.LOAD_ROLE_SUCCESS, roles } };
export function loadPermissionTypeSuccess(permissions) { return { type: types.LOAD_PERMISSION_TYPES_SUCCESS, permissions}};
export function resetPasswordSuccess(user) { return { type: types.RESET_PASSWORD_SUCCESS, user } };

export function updateProjectSuccess(project) { return { type: types.UPDATE_PROJECT_SUCCESS, project } };
export function createProjectSuccess(project) { return { type: types.CREATE_PROJECT_SUCCESS, project } };
export function getProjectSuccess(project) { return { type: types.GET_PROJECT_SUCCESS, project } };

export function updateFatigueDefaultSuccess(fatigueDefault) { return { type: types.UPDATE_FATIGUE_DEFAULT_SUCCESS, fatigueDefault } };
export function createFatigueDefaultSuccess(fatigueDefault) { return { type: types.CREATE_FATIGUE_DEFAULT_SUCCESS, fatigueDefault } };
export function getFatigueDefaultSuccess(fatigueDefault) { return { type: types.GET_FATIGUE_DEFAULT_SUCCESS, fatigueDefault } };

export function loadJobTypeSuccess(jobTypes) { return { type: types.LOAD_JOB_TYPE_SUCCESS, jobTypes } };
export function updateJobTypeSuccess(jobType) { return { type: types.UPDATE_JOB_TYPE_SUCCESS, jobType } };
export function createJobTypeSuccess(jobType) { return { type: types.CREATE_JOB_TYPE_SUCCESS, jobType } };

export function updateCompanySuccess(company) { return { type: types.UPDATE_COMPANY_SUCCESS, company } };
export function createCompanySuccess(company) { return { type: types.CREATE_COMPANY_SUCCESS, company } };

export function getCompanySuccess(company) {return{ type:types.GET_COMPANY_SUCCESS, company}};

export function loadAccidentTypeSuccess(accidentTypes) { return { type: types.LOAD_ACCIDENT_TYPE_SUCCESS, accidentTypes}}

export function loadHomeStatsSuccess(stats) { return { type: types.LOAD_HOME_STATS_SUCCESS, stats } };

export function loadUserLocationSuccess(userLocation) { return { type: types.LOAD_USERLOCATION_SUCCESS, userLocation }};
export function createUserLocationSuccess(userLocation) { return { type: types.CREATE_USERLOCATION_SUCCESS, userLocation } };
export function updateUserLocationSuccess(userLocation) { return { type: types.UPDATE_USERLOCATION_SUCCESS, userLocation } };
export function deleteUserLocationSuccess(userLocation) { return { type: types.DELETE_USERLOCATION_SUCCESS, userLocation } };

export function updateTravelTimeSuccess(travelTime) { return { type: types.UPDATE_TRAVELTIME_SUCCESS, travelTime } };
export function createTravelTimeSuccess(travelTime) { return { type: types.CREATE_TRAVELTIME_SUCCESS, travelTime } };
export function getTravelTimeSuccess(travelTime) { return { type: types.GET_TRAVELTIME_SUCCESS, travelTime } };

export function loginSuccess(user) { return { type: types.LOGIN_SUCCESS, user }};
export function forgotPasswordSuccess(email) { return { type: types.FORGOT_PASSWORD_SUCCESS, email }};
export function silentLogin(user) { return { type: types.SILENT_LOGIN, user }};
export function loginFailure(user) { return { type: types.LOGIN_FAILURE, user }};
export function forgotPasswordFailure(email) { return { type: types.FORGOT_PASSWORD_FAILURE, email }};
export function logoutSuccess(user) { return { type: types.LOGOUT, user }};

export function login(user, password, client) {
    return function (dispatch) {
        dispatch(beginAjaxCall());
        return AuthService.login(user, password, client)
            .then(res =>{    
                dispatch(loginSuccess(res));
                return 'success';
            })
            .catch(err =>{
                dispatch(loginFailure(err));
                dispatch(errorAjaxCall());
                return 'failure';
            })
    }
}

export function forgotPassword(email, client) {
    return function (dispatch) {
        dispatch(beginAjaxCall());
        return AuthService.forgotPassword(email, client)
             .then(res =>{    
                dispatch(forgotPasswordSuccess(res));
                return 'success';
            })
            .catch(err =>{
                dispatch(forgotPasswordFailure(err));
                dispatch(errorAjaxCall());
                return 'failure';
            })
    }
}

export function logout() {
    return function (dispatch) {
        dispatch(beginAjaxCall());
        return AuthService.logout().then(f => {
            dispatch(logoutSuccess());
        })
    }
}

export function loadMenu() {
    return function (dispatch) {
        dispatch(beginAjaxCall());
        return AdminApi.getMenu().then(menu => {
            dispatch(loadMenuSuccess(menu.data));
        }).catch(error => {
            dispatch(errorAjaxCall());
            throw (error);
        });
    };
}


export function load(params, entity) {
    return function (dispatch) {
        dispatch(beginAjaxCall());
        if (entity === 'company')
            return AdminApi.get('/api/company?id=0', params).then((items) => {
                console.log('success: company');
                dispatch(loadSuccess({type: types.LOAD_COMPANY_SUCCESS}, items.data));
            }).catch(error => {
                dispatch(errorAjaxCall());
                throw (error);
            });
        else if (entity === 'project')
            return AdminApi.get('/api/project', params).then((items) => {
                console.log('success: project');
                dispatch(loadSuccess({type: types.LOAD_PROJECT_SUCCESS}, items.data));
            }).catch(error => {
                dispatch(errorAjaxCall());
                throw (error);
            });
        else if (entity === 'client')
            return AdminApi.get('/api/client', params).then((items) => {
                console.log('success: client');
                dispatch(loadSuccess({type: types.LOAD_CLIENT_SUCCESS}, items.data));
            }).catch(error => {
                dispatch(errorAjaxCall());
                throw (error);
            });
        else if (entity === 'signInLocation')
            return AdminApi.get('/api/signInLocation', params).then((items) => {
                console.log('success: signInLocation');
                dispatch(loadSuccess({type: types.LOAD_PROJECT_SUCCESS}, items.data));
            }).catch(error => {
                dispatch(errorAjaxCall());
                throw (error);
            });
        else if (entity === 'travelTime')
            return AdminApi.get('/api/travelTime', params).then((items) => {
                console.log('success: travelTime');
                dispatch(loadSuccess({type: types.LOAD_TRAVELTIME_SUCCESS}, items.data));
            }).catch(error => {
                dispatch(errorAjaxCall());
                throw (error);
            });
        else if (entity === 'user')
            return AdminApi.get('/api/user', params).then((items) => {
                console.log('success: user');
                dispatch(loadSuccess({type: types.LOAD_USER_SUCCESS}, items.data));
            }).catch(error => {
                dispatch(errorAjaxCall());
                throw (error);
            });
        else if (entity === 'fatigueDefaults')
            return AdminApi.get('/api/fatigueDefaults', params).then((items) => {
                console.log('success: fatigueDefaults');
                dispatch(loadSuccess({type: types.LOAD_FATIGUE_DEFAULT_SUCCESS}, items.data));
            }).catch(error => {
                dispatch(errorAjaxCall());
                throw (error);
            });
        else if (entity === 'jobWorkload')
            return AdminApi.get('/api/jobWorkload', params).then((items) => {
                console.log('success: jobWorkload');
                dispatch(loadSuccess({type: types.LOAD_JOBWORKLOAD_SUCCESS}, items.data));
            }).catch(error => {
                dispatch(errorAjaxCall());
                throw (error);
            });
        else if (entity === 'jobAttention')
            return AdminApi.get('/api/jobAttention', params).then((items) => {
                console.log('success: jobAttention');
                dispatch(loadSuccess({type: types.LOAD_JOBATTENTION_SUCCESS}, items.data));
            }).catch(error => {
                dispatch(errorAjaxCall());
                throw (error);
            });
        else if (entity === 'permissionTypes')
            return AdminApi.get('/api/permissionTypes', params).then((items) => {
                console.log('success: permissionTypes');
                dispatch(loadSuccess({type: types.LOAD_PERMISSION_TYPES_SUCCESS}, items.data));
            }).catch(error => {
                dispatch(errorAjaxCall());
                throw (error);
            });
    }
}

export function remove(id, entity) {
       
    return function (dispatch) {
        dispatch(beginAjaxCall());
        if (entity === 'company')
            return AdminApi.delete('/api/company', id).then((items) => {
                dispatch(removeSuccess({type: types.REMOVE_COMPANY_SUCCESS}, id));
            }).catch(error => {
                dispatch(errorAjaxCall());
                throw (error);
            });
        else if (entity === 'project')
            return AdminApi.delete('/api/project', id).then((items) => {
                dispatch(removeSuccess({type: types.REMOVE_PROJECT_SUCCESS}, id));
            }).catch(error => {
                dispatch(errorAjaxCall());
                throw (error);
            });
        else if (entity === 'travelTime')
            return AdminApi.delete('/api/traveltime', id).then((items) => {
                dispatch(removeSuccess({type: types.REMOVE_TRAVELTIME_SUCCESS}, id));
            }).catch(error => {
                dispatch(errorAjaxCall());
                throw (error);
            });
        else if (entity === 'user')
            return AdminApi.delete('/api/user', id).then((items) => {
                dispatch(removeSuccess({type: types.REMOVE_USER_SUCCESS}, id));
            }).catch(error => {
                dispatch(errorAjaxCall());
                throw (error);
            });
        else if (entity === 'fatigueDefaults')
            return AdminApi.delete('/api/fatigueDefaults', id).then((items) => {
                dispatch(removeSuccess({type: types.REMOVE_FATIGUE_DEFAULT_SUCCESS}, id));
            }).catch(error => {
                dispatch(errorAjaxCall());
                throw (error);
            });
        
      
    }
}

export function getFatigueDefault(id){
    return function (dispatch) {
        dispatch(beginAjaxCall());
        return AdminApi.getFatigueDefault(id).then(fatigue => {
            dispatch(getFatigueDefaultSuccess(fatigue.data));
        }).catch(error => {
            dispatch(errorAjaxCall());
            throw (error);
        });
    };
}


export function getTravelTime(id){
    return function (dispatch) {
        dispatch(beginAjaxCall());
        return AdminApi.getTravelTime(id).then(travel => {
            dispatch(getTravelTimeSuccess(travel.data));
        }).catch(error => {
            dispatch(errorAjaxCall());
            throw (error);
        });
    };
}

export function getUser(id){
    return function (dispatch) {
        dispatch(beginAjaxCall());
        return AdminApi.getUser(id).then(user => {
            console.log(user)
            dispatch(getUserSuccess(user.data));
        }).catch(error => {
            dispatch(errorAjaxCall());
            throw (error);
        });
    };
}

export function getCompany(id){
    return function (dispatch) {
        dispatch(beginAjaxCall());
        return AdminApi.getCompany(id).then(company => {
            dispatch(getCompanySuccess(company.data));
        }).catch(error => {
            dispatch(errorAjaxCall());
            throw (error);
        });
    };
}

export function getProject(id){
    return function (dispatch) {
        dispatch(beginAjaxCall());
        return AdminApi.getProject(id).then(project => {
            dispatch(getProjectSuccess(project.data));
        }).catch(error => {
            dispatch(errorAjaxCall());
            throw (error);
        });
    };
}

export function loadRoles(i, j) {
    return function (dispatch) {
        dispatch(beginAjaxCall());
        return AdminApi.getRoles(i, j).then(roles => {
            dispatch(loadRolesSuccess(roles.data));
        }).catch(error => {
            dispatch(errorAjaxCall());
            throw (error);
        });
    };
}


export function loadPermissionTypes() {
    return function (dispatch) {
        dispatch(beginAjaxCall());
        return AdminApi.getPermissionTypes().then(permissions => {
            dispatch(loadPermissionTypeSuccess(permissions.data));
        }).catch(error => {
            dispatch(errorAjaxCall());
            throw (error);
        });
    };
}

export function loadAccidentType() {
    return function (dispatch) {
        dispatch(beginAjaxCall());
        return AdminApi.getAccidentType().then(types => {
            console.log('success: loadAccidentType');
            dispatch(loadAccidentTypeSuccess(types.data));
        }).catch(error => {
            console.log('error: loadAccidentType');
            dispatch(errorAjaxCall());
            throw (error);
        });
    };
}

export function loadUserLocation() {
    return function (dispatch) {
        dispatch(beginAjaxCall());
        return AdminApi.getUserLocation().then(location => {
            console.log('success: loadUserLocation');
            dispatch(loadUserLocationSuccess(location.data));
        }).catch(error => {
            console.log('error: loadUserLocation');
            dispatch(errorAjaxCall());
            throw (error);
        });
    };
}

export function loadJobType() {
    return function (dispatch) {
        dispatch(beginAjaxCall());
        return AdminApi.getJobType().then(jobType => {
            console.log('success: loadJobType');
            dispatch(loadJobTypeSuccess(jobType.data));
        }).catch(error => {
            console.log('error: loadJobType');
            dispatch(errorAjaxCall());
            throw (error);
        });
    };
}

export function loadHomeStats(week) {
    return function (dispatch) {
        dispatch(beginAjaxCall());
        return AdminApi.getHomeStats(week).then(stats => {
            console.log('success: loadHomeStats');
            dispatch(loadHomeStatsSuccess(stats.data));
        }).catch(error => {
            console.log('error: loadHomeStats');
            dispatch(errorAjaxCall());
            throw (error);
        });
    };
}


export function saveUser(obj, client) {
    return function (dispatch, getState) {
        dispatch(beginAjaxCall());
        return AdminApi.saveUser(obj, client).then(user => {
            user.data.id !== '' ? dispatch(updateUserSuccess(user.data)) :
                dispatch(createUserSuccess(user.data))
        }).catch(error => {
            dispatch(errorAjaxCall());
            throw (error);
        });
    };
}

export function saveTravelTime(obj) {
    return function (dispatch, getState) {
        dispatch(beginAjaxCall());
        return AdminApi.saveTravelTime(obj).then(travelTime => {
            travelTime.data.travelTimeId > 0 ? dispatch(updateTravelTimeSuccess(travelTime.data)) :
                dispatch(createTravelTimeSuccess(travelTime.data))
        }).catch(error => {
            dispatch(errorAjaxCall());
            throw (error);
        });
    };
}

export function reCalculateTravelTime() {
    return function (dispatch, getState) {
        dispatch(beginAjaxCall());
        return AdminApi.reCalculateTravelTime().then(
             dispatch(getTravelTime(0))
        ).catch(error => {
            dispatch(errorAjaxCall());
            throw (error);
        });
    };
}

export function saveUserLocation(obj) {
    return function (dispatch, getState) {
        dispatch(beginAjaxCall());
        return AdminApi.saveUserLocation(obj).then(userLocation => {
            console.log('success: saveUserLocation');
            userLocation.data.userLocationId > 0 ? dispatch(updateUserLocationSuccess(userLocation.data)) :
                dispatch(createUserLocationSuccess(userLocation.data))
        }).catch(error => {
            console.log('error: saveUserLocation');
            dispatch(errorAjaxCall());
            throw (error);
        });
    };
}

export function resetPassword(obj) {
    return function (dispatch, getState) {
        dispatch(beginAjaxCall());
        return AdminApi.resetPassword(obj).then(user => {
            dispatch(resetPasswordSuccess(user.data));
        })
        .catch(error => {
            dispatch(errorAjaxCall());
            throw (error);
        });
    };
}


export function saveProject(obj) {
    return function (dispatch, getState) {
        dispatch(beginAjaxCall());
        return AdminApi.saveProject(obj).then(project => {
            project.data.projectId > 0 ? dispatch(updateProjectSuccess(project.data)) :
                dispatch(createProjectSuccess(project.data))
        }).catch(error => {
            dispatch(errorAjaxCall());
            throw (error);
        });
    };
}

export function saveCompany(obj) {
    return function (dispatch, getState) {
        dispatch(beginAjaxCall());
        return AdminApi.saveCompany(obj).then(company => {
            company.data.companyId > 0 ? dispatch(updateCompanySuccess(company.data)) :
                dispatch(createCompanySuccess(company.data))
        }).catch(error => {
            dispatch(errorAjaxCall());
            throw (error);
        });
    };
}

export function saveJobType(obj) {
    return function (dispatch, getState) {
        dispatch(beginAjaxCall());
        return AdminApi.saveJobType(obj).then(jobType => {
            if (jobType.data) {
            jobType.data.jobTypeId > 0 ? dispatch(updateJobTypeSuccess(jobType.data)) :
                dispatch(createJobTypeSuccess(jobType.data))
            }
        }).catch(error => {
            dispatch(errorAjaxCall());
            throw (error);
        });
    };
}

export function saveFatigueDefaults(obj) {
    return function (dispatch, getState) {
        dispatch(beginAjaxCall());      
        return AdminApi.saveFatigueDefaults(obj).then(fatigueDefault => {
            console.log('success: saveFatigueDefault');
            fatigueDefault.data.fatigueDefaultId > 0 ? dispatch(updateFatigueDefaultSuccess(fatigueDefault.data)) :
                dispatch(createFatigueDefaultSuccess(fatigueDefault.data))
        }).catch(error => {
            console.log('error: saveFatigueDefault');
            dispatch(errorAjaxCall());
            throw (error);
        });
    };
}

export function deleteFatigueDefaults(id) {
    return function (dispatch, getState) {
        dispatch(beginAjaxCall());      
        return AdminApi.deleteFatigueDefaults(id).then(fatigueDefault => {
            console.log('success: saveFatigueDefault');
            
        }).catch(error => {
            console.log('error: saveFatigueDefault');
            dispatch(errorAjaxCall());
            throw (error);
        });
    };
}

export function deleteUserLocation(id) {
    return function (dispatch, getState) {
        dispatch(beginAjaxCall());      
        return AdminApi.deleteUserLocation(id).then(userLocato => {
            console.log('success: deleteUserLocation');
            
        }).catch(error => {
            console.log('error: deleteUserLocation');
            dispatch(errorAjaxCall());
            throw (error);
        });
    };
}

